
import XHeader from 'vux/src/components/x-header/index.vue'

export default {

components: {
XHeader
},
created(){
this.flag=this.$route.query.flag
this.title=this.$route.query.title
console.log("flag="+this.flag)
},
methods: {

},
data(){
return{
flag:""
}
}
}



// WEBPACK FOOTER //
// ./src/views/ntalk/loginHeader.vue